import { render, staticRenderFns } from "./task-list.vue?vue&type=template&id=3d936082&scoped=true&"
import script from "./task-list.vue?vue&type=script&lang=js&"
export * from "./task-list.vue?vue&type=script&lang=js&"
import style0 from "./task-list.vue?vue&type=style&index=0&id=3d936082&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d936082",
  null
  
)

export default component.exports